import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppState} from '@app/store/app.states';
import {environment} from '@environments/environment';
import {select, Store} from '@ngrx/store';
import {RefreshProjectsList, RefreshSurveysList} from '@store/actions/projects.actions';

import {ChangeCurrentProjectId} from '@store/actions/auth.actions';
import * as projectsSelector from '@store/selectors/project.selector';
import {first, retry} from 'rxjs/operators';
import {AuthService} from '@app/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService {
  private BASE_URL = environment.apiUrl;

  getProjectList() {
    // console.log('[getProjectList] - Refresh project list');
    const url = `${this.BASE_URL}/projects`;
    return this.http.get<any>(url);
  }

  getRecentProjectList(limit: number = 50) {

    let url = '';

    if (this.authService.getContext().type === 'annotator') {

      // console.log('[getProjectList] - Refresh project list');
      url = `${this.BASE_URL}/projects/actions`;

    } else {

      // console.log('[getProjectList] - Refresh project list');
      url = `${this.BASE_URL}/4dm1n/actions`;

    }

    return this.http.post<any>(url, {
      action: 'getRecentProjects',
      params: {
        limit
      }
    });


  }

  getOrganizationList(limit: number = 150, forceOrganizationId = []) {
    // console.log('[getOrganization LIst] - Refresh project list');
    const url = `${this.BASE_URL}/projects/actions`;
    return this.http.post<any>(url, {
      action: 'getOrganizationList',
      params: {
        limit,
        forceOrganizationId // <--- Later, mettre les organizations sélectionnées seulement, ou déduite des sondages ?
      }
    });
  }

  // refreshProjectList(forceRefresh = false) {
  //   console.log('[refreshProjectList] - Refresh project list & dispaych [8] - message');
  //   this.getProjectList();
  //   this._store.dispatch(new RefreshProjectsList({forceRefresh}));
  // }

  changeProject(projectId) {
    this.store
      .select(projectsSelector.getProjectFromProjectId, {projectId})
      .pipe(first())
      .subscribe((data) => {
        this.store.dispatch(new ChangeCurrentProjectId(data));
      });
  }

  getSurveyList(projectId) {
    // console.log('Refresh surveyList list');
    const url = `${this.BASE_URL}/surveys/${projectId}`;
    return this.http.get<any>(url);
  }

  //
  // ExtProfils
  // ---------------------------------------------------------------------------------------------------------------------------------------

  getExtProfilsList(extList: string[] = [], forDashboard = false) {
    // Charge tout si aucun ext-profile demandé
    if (this.authService.isLogged()) {

      // console.log('Refresh Ext Profils list');
      const url = `${this.BASE_URL}/extProfils/list`;
      // return this.http.get<any>(url);
      return this.http.post<any>(url, {
        extList,
        forDashboard
      });

    } else {

      const url = `${this.BASE_URL}/4dm1n/publicActions`;
      return this.http.post<any>(url, {
        action: 'getExtProfilsList',
        params: {
          extList,
          forDashboard: true
        }
      });
    }

  }

  getExtProfilsListLegacy() {
    // console.log('Refresh ext Profils Legacy list');
    const url = `${this.BASE_URL}/extProfils/listLegacy`;
    return this.http.get<any>(url);
  }

  saveExtProfilList(list) {
    const url = `${this.BASE_URL}/extProfils/update`;
    return this.http.post<any>(url, {
      list
    });
  }

  deleteExtProfilList(list) {
    const url = `${this.BASE_URL}/extProfils/delete`;
    return this.http.post<any>(url, {
      list
    });
  }

  getStats(uuid) {
    const url = `${this.BASE_URL}/extProfils/stats`;
    return this.http.post<any>(url, {
      uuid: [uuid],
      includePublicUsers: true
    });
  }

  getSavedList() {
    const url = `${this.BASE_URL}/extProfils/savedList`;
    return this.http.get<any>(url);
  }

  saveSavedList(list) {
    const url = `${this.BASE_URL}/extProfils/savedList`;
    return this.http.post<any>(url, {list});
  }

  //
  // Medias
  // ---------------------------------------------------------------------------------------------------------------------------------------
  getMediasList(projectId) {
    // console.log('Refresh medias list', projectId);
    const url = `${this.BASE_URL}/project/${projectId}/medias`;
    return this.http.get<any>(url);
  }

  //
  // Communities : soon deprecated --> src/@shared/inbe-communities-selector/inbe-communities.service.ts:18
  // ---------------------------------------------------------------------------------------------------------------------------------------
  getCommunitiesList() {
    // console.log('Refresh Communities list');
    const url = `${this.BASE_URL}/projects/communities`;
    return this.http.get<any>(url);
  }

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private authService: AuthService
  ) {
  }
}
